// This file is generated by generate-entities.ts. Please DO NOT edit this file directly.
import { getAuthHeaders } from "@/shared/api/authHeaders";
import { keysToSnakeCase } from "@/shared/lib/case";
import { useMutation } from "@tanstack/react-query";
import { FreightMatching } from "@x-mile/api-contract";
import type { PutOffersCargoMutationVariables } from "../model";

export const usePutOffersCargo = () => {
  const authHeaders = getAuthHeaders();
  const mutateResult = useMutation({
    mutationFn: (variables: PutOffersCargoMutationVariables) => {
      // 除外するプロパティを削除（型キャストで除外プロパティへのアクセスを許可）
      const { processId, companyId, sourceOffercargoId, stage, ...cleanData } =
        variables.data as PutOffersCargoMutationVariables["data"] & {
          processId?: unknown;
          companyId?: unknown;
          sourceOffercargoId?: unknown;
          stage?: unknown;
        };

      return FreightMatching.putOffersCargo(
        variables.id,
        // バックエンド（rails）ではキーがスネークケースになっているため、リクエストボディをスネークケースに変換する
        keysToSnakeCase(cleanData),
        {
          headers: authHeaders.isOk() ? authHeaders.value : {},
        },
      );
    },
  });
  return mutateResult;
};

// TODO: api-contract側でmockを生成しないことになったので、自前でmockを生成する
// export const usePutOffersCargoMock = () => {
//   const [workerStarted, setWorkerStarted] = useState(false);
//   void (async () => {
//     if (!workerStarted) {
//       await FreightMatching.startMockServerWoker(
//         FreightMatching.getPutOffersCargoMockHandler(),
//       );
//       setWorkerStarted(true);
//     }
//   })();
//   return usePutOffersCargo();
// };
